const SearchInput = ({
  onChangedSearch,
  placeholder = 'Search',
  searchValue,
  useSearchIcon = true,
}: {
  searchValue?: string;
  onChangedSearch?: (searchValue: string) => void;
  placeholder?: string;
  useSearchIcon?: boolean;
}) => {
  return (
    <div className="relative">
      <input
        type="search"
        enterKeyHint="search"
        placeholder={placeholder}
        className="w-full rounded-lg border border-line p-2 pl-10"
        value={searchValue}
        onChange={(e) => onChangedSearch?.(e.target.value)}
      />
      {useSearchIcon && (
        <svg
          className="absolute top-3 left-3 size-4 text-inkDisabled"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
      )}
    </div>
  );
};

export default SearchInput;
